<div class="group-tutorization">
  <div class="mars-tutorization">
    <div class="gl-tabs">
      <div class="gl-tabs__options">
        <div
          class="gl-tabs__options--item"
          [ngClass]="{ active: tab === 'questions' }"
          (click)="changeView('questions')"
        >
          {{ 'tutorization.questions' | translate }}
        </div>
        <div class="gl-tabs__options--item" [ngClass]="{ active: tab === 'messages' }" (click)="changeView('messages')">
          {{ 'tutorization.messages' | translate }}
        </div>
        <div
          class="gl-tabs__options--item"
          [ngClass]="{ active: tab === 'discussion' }"
          (click)="changeView('discussion')"
        >
          {{ 'debates.label' | translate }}
        </div>
      </div>

      <div
        *lmsProfileGuard="'mars.tutorization.questions'"
        class="gl-tabs__content"
        [ngClass]="{ active: tab === 'questions' }"
      >
        <lms-mars-questions [listId]="groupQuestionsListId" [group]="group"></lms-mars-questions>
      </div>

      <div
        *lmsProfileGuard="'mars.tutorization.messages'"
        class="gl-tabs__content"
        [ngClass]="{ active: tab === 'messages' }"
      >
        <lms-mars-messages [listId]="groupMessagesListId" [group]="group"></lms-mars-messages>
      </div>

      <div
        *lmsProfileGuard="'mars.tutorization.debates'"
        class="gl-tabs__content"
        [ngClass]="{ active: tab === 'discussion' }"
      >
        <lms-mars-debates [listId]="groupDebatesListId" [group]="group"></lms-mars-debates>
      </div>
    </div>
  </div>
</div>
